import { LevelSpecification } from '../../LevelSpecification';

export const hasDrawnGeometry = (levelSpecification?: LevelSpecification): boolean =>
  !!levelSpecification?.geometry?.geometry; // TODO : Remove the "?" of geometry?
